<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/135kW/135kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">135kW Three-in-one Electric Drive Assembly</div>
                <div class="detail-banner-desc transmission">
                    <div class="detail-desc">
                        <div>
                            Highly integrated,compact structure，easy to match;<br />
                        </div>
                        <div>
                            Lightweight design with high torque/weight ratio;<br />
                        </div>
                        <div>
                            Low harmonic winding high gear coincident degree≥4.0,better NVH performance;<br />
                        </div>
                        <div>
                            Hairpin winding high filling ratio,high-efficiency bearings,less oil,assembly maximum
                            efficiency reaches 94%.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/135kW/135kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">135kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">16000rpm</div>
                                    <div class="k">Max Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2849N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">450*495*295</div>
                                    <div class="k">Dimension X*Y*Z(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">69kg</div>
                                    <div class="k">Weight</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '135kW Three-in-one Electric Drive Assembly - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/135.html'
};

import { createApp } from 'vue';
import App from './135.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./135.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
